export type DiagnosticStatus = 'Pending' | 'Completed' | 'Failed' | 'TimedOut';

export const DiagnosticStatuses = {
  Pending: 'Pending' as DiagnosticStatus,
  Completed: 'Completed' as DiagnosticStatus,
  Failed: 'Failed' as DiagnosticStatus,
  TimedOut: 'TimedOut' as DiagnosticStatus,
};

export interface DiagnosticResult {
  id: string;
  updatedAt: string;
  userId?: string | null;
  status: DiagnosticStatus;
  errorCode?: string | null;
  message?: string | null;
}
